import account from './account/text.js';
import features from './features/text.js';
import navigation from './navigation/text.js';
import routing from './routing/texts.js';

export default {
  account,
  navigation,
  features,
  routing,
  notifications: {
    notAllowedInBrowser: {
      notes:
        'The user has not yet allowed the web site to use the Notification api in the browser',
      message: 'Push notifications are not yet allowed',
    },
    errorBlockedInBrowser: {
      notes:
        'The user has previously blocked the web site from using the Notification api in the browser',
      message: 'Push notifications are blocked in this browser',
    },
    allow: {
      notes: 'Label for action to allow notifications',
      message: 'Allow',
    },
    dontShowAgain: {
      notes: 'Label for action hide info message about notifications',
      message: "Don't show again",
    },
  },
};
